import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';
import { DocumentContentMap, SupportedDocumentType } from 'src/shared/types/documents.type';
import { TypeDocument } from 'src/shared/types/documents';

export const fetchDocument = async (id: string, type: TypeDocument): Promise<number[] | null> => {
  const { data } = await HttpHandler({
    method: 'GET',
    url: `${environment.DOCUMENTS_APP_URL}/documents/pdf/client/sessions/${id}/${type}?userType=client`,
    headers: {
      'Content-Type': DocumentContentMap[SupportedDocumentType.PDF],
    },
  });

  const file = data.data;
  return file.data || null;
};

export const fetchInvoice = (id: string) => fetchDocument(id, 'invoice');

export const fetchReceiptPayment = (id: string) => fetchDocument(id, 'receipt-payment');

export const fetchRelatedSessions = (id: string) => fetchDocument(id, 'related-sessions');
